import React, { FC, ReactNode, CSSProperties } from 'react';
import { Prism } from 'react-syntax-highlighter';
import styled from 'styled-components';
import { AssetUrl } from '@cld/asset-url';
import { parseUrl } from '@cld/cloudinary-url-parser';
import { Syntax } from '../Syntax';
import codeStyle from './Code.style';

const Root = styled.div`
  ${codeStyle};
`;

export interface CodeProps {
  /** The language to highlight, one of Prism styles */
  syntax?: Syntax;
  showLineNumbers?: boolean;
  lineNumberContainerStyle?: CSSProperties
}

// react-syntax-highlighter doesn't support no-inline-style mode form Prism. If you don't provide inline style it includes some hljs styles inline.
// Maybe we should not use react-syntax-highlighter and use prism and refractor directly
const fakeStyle = {
  'pre[class*="language-"]': {},
};

const lineNumberContainerProps = {
  style: {
    float: 'left',
    paddingRight: '10px',
    display: 'inline-block',
  },
};

const getPrismCode = (syntax: Syntax, children: ReactNode, showLineNumbers?: boolean, lineNumberContainerStyle?: CSSProperties) => (
  <Prism
    showLineNumbers={showLineNumbers}
    lineNumberContainerProps={lineNumberContainerStyle ? {
      ...lineNumberContainerProps,
      style: { ...lineNumberContainerProps.style, ...lineNumberContainerStyle }
    } : lineNumberContainerStyle}
    language={syntax}
    useInlineStyles={false}
    style={fakeStyle}
  >
    {children}
  </Prism>
);

const getUrlCode = (children: ReactNode) => {
  const sections = parseUrl(String(children));

  return (
    <pre>
      <code>
        <AssetUrl.FromObject {...sections} />
      </code>
    </pre>
  );
};

/**
 * A view that renders code of a specified language and colorful syntax
 */
export const Code: FC<CodeProps> = ({ showLineNumbers , syntax, children, lineNumberContainerStyle, ...rest }) => (
  <Root {...rest}>{syntax && (syntax === 'url' ? getUrlCode(children) : getPrismCode(syntax, children, showLineNumbers, lineNumberContainerStyle))}</Root>
);
